import React, { useState, useEffect } from "react";
import avatar from "./images/Linux-Avatar.svg";
import "./Nav.css";

function Nav() {
	const [show, handleShow] = useState(false);

	// Add a scroll event listener to the navabar
	useEffect(() => {
		window.addEventListener("scroll", () => {
			if (window.scrollY > 100) {
				handleShow(true);
			} else handleShow(false);
		});
		return () => {
			window.removeEventListener("scroll");
		};
	}, []);
	return (
		<div className={`nav ${show && "nav__black"}`}>
			<img
				className="nav__logo"
				src="https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg"
				alt="Netflix Logo"
			/>

			<img className="nav__avatar" src={avatar} alt="Netflix Logo" />
		</div>
	);
}

export default Nav;
